module.exports = __webpack_public_path__ + "cb90c13b02ad15ea9ccca2cedcec6982.pdf";